import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-paper px-8 py-24 sm:px-14 sm:py-28" data-id="element-93" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-94" data-mp="1o4f0oolspeck">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 rotate-[-8deg] text-pen sm:h-44 sm:w-44" role="img" aria-label="Garantie de 7 jours" data-id="element-95" data-mp="222wiy6sxlyn3">
          <defs data-id="element-96" data-mp="19eheufbc90qj">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-97" data-mp="19dzdx5dqdyca" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-98" data-mp="14gz88vksmxlp" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-99" data-mp="1j5c29n0bm6dk" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="Inter, sans-serif" data-id="element-100" data-mp="1ed26hqciyc3d">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-101" data-mp="qmew8yf4zadn">
              SATISFAIT OU REMBOURSÉ · SATISFAIT OU REMBOURSÉ ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="'Instrument Serif', Georgia, serif" data-id="element-102" data-mp="oz03bv02a0ob">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="Inter, sans-serif" data-id="element-103" data-mp="yp2x3xf0binp">
            JOURS
          </text>
        </svg>

        <div data-id="element-104" data-mp="61fh6voolg7e">
          <h2 className="font-display text-4xl leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-105" data-mp="61yx66urtuis">
            Garantie «&nbsp;Satisfait ou remboursé&nbsp;»
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-ink/75" data-id="element-106" data-mp="f0u3rk1q96mm">
            Découvrez le matériel pendant 7 jours. S’il ne correspond pas à vos attentes,
            contactez-nous par e-mail pour demander le remboursement de votre achat, conformément à
            notre politique de remboursement.
          </p>
        </div>
      </div>
    </section>;
}